import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { I18nextProvider } from "react-i18next";
import { widgetI18n } from "./lib/i18n/widgetI18n";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Focus-refetch stays enabled (default) but only fires when data is
      // older than this — kills the alt-tab refetch storm on all-day salon
      // tabs while keeping instant catch-up on return (doc 07 Phase B).
      staleTime: 30_000,
    },
  },
});

export function WidgetProviders({ children }: { children: React.ReactNode }) {
  return (
    <I18nextProvider i18n={widgetI18n}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </I18nextProvider>
  );
}

export { queryClient };
